'use client'

import { useState } from 'react'

import { Button } from '@canyon/ui/Button'
import { IconText } from '@canyon/ui/IconText'
import { objectToQueryString } from '@canyon/utils'
import { sendGTMEvent } from '@next/third-parties/google'
import { useSearchParams } from 'next/navigation'
import { signIn } from 'next-auth/react'

import { GoogleLogo } from '@/components/assets/GoogleLogo'
import { trackMetaConversion } from '@/utils/apiClient'

interface IGoogleOAuthButtonProps {
  type: 'signin' | 'signup'
}

export const GoogleOAuthButton = ({ type }: IGoogleOAuthButtonProps) => {
  const [isGoogleLoading, setIsGoogleLoading] = useState<boolean>(false)
  const searchParams = useSearchParams()
  const referral_code = searchParams?.get('referral_code')
  if (referral_code) {
    // 3 days
    document.cookie = `referral-code=${referral_code}; SameSite=None; path=/; max-age=259200; Secure`
  }

  const handleGoogleSignIn = async () => {
    setIsGoogleLoading(true)

    if (type === 'signup') {
      // Server-side tracking via Meta Conversion API
      trackMetaConversion('CompleteRegistration', {
        browser_id: 'google-oauth',
        click_id: searchParams?.get('fbclid') || undefined,
        custom_data: {
          registration_method: 'google',
        },
        event_id: `signup_google_${Date.now()}`,
        event_name: 'CompleteRegistration',
        external_id: 'google-signup',
        user_data: {
          client_user_agent: navigator.userAgent,
        },
      })

      sendGTMEvent({
        event: 'conversion',
      })
    }

    const response = await signIn('google', {
      callbackUrl: searchParams
        ? `${window.location.origin}?${objectToQueryString(searchParams)}`
        : window.location.origin,
    })
  }

  const text = 'Continue with Google'

  return (
    <Button
      className="h-[40px] w-full"
      disabled={isGoogleLoading}
      loading={isGoogleLoading}
      onClick={handleGoogleSignIn}
      size="lg"
      variant="outline"
    >
      <IconText leftIcon={<GoogleLogo className="h-6 w-6" />}>{text}</IconText>
    </Button>
  )
}
